import React from 'react';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import authStorage from '../../../storages/mobx/authStorage';
import twitterAuth from '../../providers/twitterAuth';

function TwitterAuthButton() {
  return (
    <button
      className="btn social-btn btn-twitter d-inline-block"
      type="button"
      onClick={() => twitterAuth(authStorage.setCredientials, authStorage.processError)}
    >
      <i className="fa fa-twitter" />
    </button>
  );
}

TwitterAuthButton.propTypes = {};

export default TwitterAuthButton;
